<template>
    <div class="mousemover" :style="{left:x+'px',top:y+'px'}" @mousedown="go">
        <slot/>
    </div>
</template>
<script>
export default {
    name: "mousemover",
    props: ["handler"],
    methods: {
        go(e){
            //console.log(this);
            if(this.handler===''){
                this.moveStart(e);
            }
            this.$emit('mousedown')
        },
        onMove(e) {
            //console.log("MOVE",this);
            let { startX, startY } = this;
            let { pageX, pageY } = e;
            let d = { x: pageX - startX, y: pageY - startY };
            this.x = this.startPosX + d.x;
            this.y = this.startPosY + d.y;
            this.$emit('move',{x:this.x, y:this.y, dx:d.x, dy:d.y});
        },
        moveStart(e) {
            document.addEventListener('mousemove', this.onMove);
            document.addEventListener('mouseup', this.moveStop);
            this.startX = e.pageX;
            this.startY = e.pageY;
            this.startPosX = this.x;
            this.startPosY = this.y;
        },
        moveStop() {
            document.removeEventListener('mousemove', this.onMove);
            document.removeEventListener('mouseup', this.moveStop);
        }
    },
    data() {
        return {
            x: 400,
            y: 200,
            startX: 0,
            startY: 0,
            startPosX: 0,
            startPosY: 0
        }
    }
}
</script>
<style scoped>
.mousemover {
    position: absolute;
}
</style>